import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import React from 'react'
import { BpmCharts } from './BpmCharts'
import { ErrorBoundary } from './ErrorBoundary'

export const BpmChartsContainer: React.FC = () => {
    const { getToken } = React.useContext(AuthContext)
    React.useEffect(() => {}, [getToken])
    return (
        <div id="bpm_charts_container">
            <ErrorBoundary>
                <BpmCharts
                    userToken={getToken()}
                    manufacturerId={null}
                    selectedTopLevelTab={null}
                    selectedEnhancedListingTab={null}
                    selectedProductDecisionsTab={null}
                    selectedProductMasterSpecTab={null}
                    defaultSectionNumber={null}
                />
            </ErrorBoundary>
        </div>
    )
}
